import { Entity } from '@core/objects';

/**
 * The basic elements for events, conditions and actions that we display in a selector
 * has a key and a description.
 * exxample: {key: 'access_version', description: 'Access to versions'}
 */
export interface AvailableRuleItem {
    key: string;
    description: string;
}

export interface AvailableRuleEventCondition extends AvailableRuleItem {
    options: Array<AvailableRuleItem>;
    values: Array<AvailableRuleConditionVariable>;
}

export interface AvailableRuleEventAction extends AvailableRuleItem {
    variables: Array<AvailableRuleActionVariable>;
}

// this is a filter for the current event selected and its condition & action keys to display
export interface AvailableCurrentEventConfig  {
    key: string;
    conditions: Array<string>;
    actions: Array<string>;
}

/**
 * october 2023 update <diego@twonas.com>
 * the available rule event element has only the keys: 
 *  - the event key, 
 *  - the event description 
 *  - the the event conditions keys and descriptions
 *  - and the event actions keys and descriptions
 */

export interface AvailableRuleEventElement {
    key: string;
    description: string;
    conditions: Array<AvailableRuleItem>;
    actions: Array<AvailableRuleItem>;
}

/**
 * october 2023 update <diego@twonas.com>
 * the available conditions follows this model
 */

export interface AvailableRuleConditionValueItem extends AvailableRuleItem {
    options: any | AvailableRuleVariableValueItemOptions; // could be an object
}

export interface AvailableRuleConditionVariable extends AvailableRuleItem {
    options: Array<AvailableRuleItem>;
    values: Array<AvailableRuleConditionValueItem>;
}

/**
 * october 2023 update <diego@twonas.com>
 * the available actions follows this model
 */
export interface AvailableRuleVariableValueItemOptions {
    color: string;
    parent?: number;
    selectable: boolean;
    title: boolean;
}

export interface AvailableRuleActionVariableValueItem extends AvailableRuleItem {
    options: any | AvailableRuleVariableValueItemOptions; // could be an object with other properties
}

export interface AvailableRuleActionVariable extends AvailableRuleItem {
    // type?: string;
    default?: string;
    options: {
        multiple: boolean;
    }
    values: Array<AvailableRuleActionVariableValueItem>;
}

/**
 * Each item in the conditon or actions will follow this interfaces associated with form
 */

/**
 * Each rule form item has a type, to match condition or action form
 */
export enum AvailableRuleItemFormTypes {
    condition = 'condition',
    action = 'action'
}

export interface AvailableRuleItemFormSearch {
    term: string;
    found: Array<AvailableRuleActionVariableValueItem> | Array<AvailableRuleConditionValueItem>; // TODO definedd maybe later to match both conditions and actions
}

export interface SettingsRulesEditScroll {
    key: string;
    value: number;
}

export interface AvailableRuleItemFormModel {
    id: string;
    key: string; // (available.key),
    description: string; // (available.description),
    // option?: string;  //  TODO oct-2023: could the option key in the condition (could not be for the action forms)
    // value: any, // TODO oct-2023: could be conditon and action item key or array keys ???
    type: AvailableRuleItemFormTypes ; // (condition/action),
    scroll:  Array<SettingsRulesEditScroll>;
    search?: AvailableRuleItemFormSearch; // optional
}


/**
 * persisted objects
 */

export interface RuleListItem {
    id: number;
    key: string;
    active: boolean;
    name: string;
}

export interface RuleEvent {
    id: number;
    key: string;
    name: string;
    conditions_control: string; // AND | OR
    conditions: Array<RuleCondition>;
    actions: Array<RuleAction>;
}

export interface RuleCondition {
    form_id?: string;
    variable: string;
    condition: string;
    value: string;
}
export type RuleActionParameterType = string | number | string[];

export interface RuleActionParameters {
      [key: string]: RuleActionParameterType;
}

export interface RuleAction {
    id: number;
    form_id?: string;
    key: string;
    parameters: RuleActionParameters
}

export class AvailableRuleItemForm implements AvailableRuleItemFormModel {
    id: string;
    key: string; //(available.key),
    // option?: string; //(available.option[0]),
    // value: any;
    description: string; // (available.description),
    type: AvailableRuleItemFormTypes; // (condition/action),
    scroll: Array<SettingsRulesEditScroll>;
    search: AvailableRuleItemFormSearch; 
    incident: string | null;
    // search: {
    //     term: string,
    //     found: [available]
    // }
    
    constructor(eventOnRule: AvailableRuleEventElement, type: AvailableRuleItemFormTypes,formVariableKey: string = '') {
        const timestamp = new Date().getTime(); // Get current timestamp
        const random = Math.random().toString(36).substring(2, 8); // Generate a random string
        this.id = `${timestamp}${random}`;
        this.type = type;
        // console.log("   NEWWWWWWWWWWWWWW FORMs "+type+ " and key [ "+formVariableKey+" ]", eventOnRule);
        // define either item is for condition or actions.
        let formItemSource = eventOnRule.conditions;
        if( type == AvailableRuleItemFormTypes.action )
            formItemSource = eventOnRule.actions
        
        if(formVariableKey !== ''){
            this.key = formVariableKey;
            let selectedItemSource = formItemSource.find(item => item.key === formVariableKey);

            if (!selectedItemSource) {
                // If formVariableKey is not present, we set incident to protect front code to break
                this.id = null;
                this.incident = "This item is no longer available."
            } else 
                this.description = selectedItemSource.description;

        } else {
            this.key = formItemSource[0].key;
            this.description = formItemSource[0].description;
            
        }
        this.search = {
            term: '',
            found: []
        }
    }
  }